import React from 'react';
import classnames from 'classnames'

import img_1860_1870_from from '../images/first_frames/1860_1870.jpg';

import img_1860_1870_to from '../images/last_intro_frames/1860_1870.jpg';
import img_1870_1880_to from '../images/last_intro_frames/1870_1880.jpg';
import img_1890_1900_to from '../images/last_intro_frames/1890_1900.jpg';
import img_1900_1910_to from '../images/last_intro_frames/1900_1910.jpg';
import img_1910_1920_to from '../images/last_intro_frames/1910_1920.jpg';
import img_1920_1930_to from '../images/last_intro_frames/1920_1930.jpg';
import img_1930_1940_to from '../images/last_intro_frames/1930_1940.jpg';
import img_1940_1950_to from '../images/last_intro_frames/1940_1950.jpg';
import img_1950_1960_to from '../images/last_intro_frames/1950_1960.jpg';
import img_1960_1970_to from '../images/last_intro_frames/1960_1970.jpg';
import img_1970_1980_to from '../images/last_intro_frames/1970_1980.jpg';
import img_1980_1990_to from '../images/last_intro_frames/1980_1990.jpg';
import img_1990_2000_to from '../images/last_intro_frames/1990_2000.jpg';
import img_2000_2010_to from '../images/last_intro_frames/2000_2010.jpg';
import img_2010_2020_to from '../images/last_intro_frames/2010_2020.jpg';

const fallbackImages = [
  img_1860_1870_from,
  img_1860_1870_to,
  img_1870_1880_to,
  img_1890_1900_to,
  img_1900_1910_to,
  img_1910_1920_to,
  img_1920_1930_to,
  img_1930_1940_to,
  img_1940_1950_to,
  img_1950_1960_to,
  img_1960_1970_to,
  img_1970_1980_to,
  img_1980_1990_to,
  img_1990_2000_to,
  img_2000_2010_to,
  img_2010_2020_to
];

const getIndexFromFrame = frameId => {
  let index = frameId >= 419
    ? Math.floor(14 + (frameId - 419) / 130)
    : Math.floor(frameId / 30);

  return Math.min(fallbackImages.length - 1, index);
}

export default class extends React.PureComponent {
  state = {
    loaded: 0,
    from: [],
    to: [],
  }

  // progress between frames, from 0 to 29
  get offset() {
    if (this.props.frameId >= 419) {
      return Math.round((this.props.frameId - 419) / 130 * 30);
    }

    return this.props.frameId % 30;
  }

  // src of left image
  get img1() {
    const index = getIndexFromFrame(this.props.frameId)

    return fallbackImages[index];
  }

  // src of right image
  get img2() {
    let index = getIndexFromFrame(this.props.frameId)
    index = Math.min(fallbackImages.length - 1, index + 1);

    return fallbackImages[index];
  }

  // opacity of right image
  get img2Opacity() {
    if (this.offset < 5) return 0;
    if (this.offset > 25) return 1;

    return (this.offset - 5) / 20;
  }

  componentDidMount() {
    fallbackImages.forEach(src => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        this.setState(prevState => ({
          loaded: prevState.loaded + 1
        }), () => {
          this.props.handleProgress((this.state.loaded / fallbackImages.length) * 100);
        });
      }
    });
  }

  render() {
    return (
      <div className={classnames('hero opacity-animated', { exited: this.props.hide })}>
        <img
          className='hero' alt=''
          key={this.img1 + '-1'}
          src={this.img1} 
        />
        <img
          className='hero' alt=''
          key={this.img2 + '-2'}
          src={this.img2}
          style={{ opacity: this.img2Opacity }}
        />
      </div>
    );
  }
}